import { render } from "./mainFooter.vue?vue&type=template&id=1edcce5c&scoped=true"
import script from "./mainFooter.vue?vue&type=script&lang=js"
export * from "./mainFooter.vue?vue&type=script&lang=js"

import "./mainFooter.vue?vue&type=style&index=0&id=1edcce5c&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edcce5c"]])

export default __exports__